module.exports = __webpack_public_path__ + "img/made-with-movement-white.87ddbc24.svg";